export { default } from './NewView';



// WEBPACK FOOTER //
// ./src/components/views/NewView/index.js